// client/src/constants/proposalMessages.js

/**
 * Centralized notification messages for match proposal actions
 * Following SRP: Separated UI text from business logic
 */

export const PROPOSAL_MESSAGES = {
  // Success messages
  ACCEPTED: 'Match proposal accepted and match scheduled!',
  REJECTED: 'Match proposal rejected',
  CANCELED: 'Match proposal canceled',
  DISMISSED: 'Proposal dismissed',

  // Error messages
  ACCEPT_FAILED: 'Failed to accept proposal',
  REJECT_FAILED: 'Failed to reject proposal',
  CANCEL_FAILED: 'Failed to cancel proposal',
  DISMISS_FAILED: 'Failed to dismiss proposal',
  UNKNOWN_ACTION: 'Unknown action',
}

/**
 * Get a failure message for a specific action
 * @param {string} action - The action that failed (accept, reject, cancel, dismiss)
 * @returns {string} - The appropriate failure message
 */
export function getFailureMessage(action) {
  const messages = {
    accept: PROPOSAL_MESSAGES.ACCEPT_FAILED,
    reject: PROPOSAL_MESSAGES.REJECT_FAILED,
    cancel: PROPOSAL_MESSAGES.CANCEL_FAILED,
    dismiss: PROPOSAL_MESSAGES.DISMISS_FAILED,
  }
  return messages[action] || `Failed to ${action} proposal`
}
